import React from "react";
import { Image } from 'react-bootstrap';

const Latest = (props) => {
  const { showcase } = props;

  return (
      <div>
        <h4>Latest Work</h4>
        <ul className="list-group list-group-horizontal mt-4">
        { showcase.map( (item, index) => (
          <li key={index} className="list-group-item p-1 bg-dark">
            <div className="overflow-hidden">
              <Image fluid src={"/images/gallery/" + item.filename} alt={item.title} />
            </div>
          </li>
          ))
        }
        </ul>
      </div>
  );
}


export default Latest;
